import React from 'react'

export type Size = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | undefined

export interface ModalReturnType<T> {
  isOpen: boolean
  title: string
  openModal: (
    psize?: Size,
    modalState?: T | undefined,
    titleAux?: string
  ) => void
  closeModal: () => void
  size: Size
  extendedProps: T | undefined
  setExtendedProps: React.Dispatch<React.SetStateAction<T | undefined>>
}

export const useModal = <T>(
  ptitle: string,
  pIsOpen: boolean = false,
  pSize: Size = 'xs'
) => {
  const [isOpen, setIsOpen] = React.useState(pIsOpen)
  const [title, setTitle] = React.useState(ptitle)
  const [size, setSize] = React.useState<Size>(pSize)
  const [extendedProps, setExtendedProps] = React.useState<T>()

  const openModal = (psize?: Size, modalState?: T, titleAux?: string) => {
    setTitle(titleAux != null ? titleAux : title)
    setIsOpen(true)
    setSize(psize || size)
    setExtendedProps(modalState)
  }

  const closeModal = () => setIsOpen(false)

  const modalReturn: ModalReturnType<T> = {
    isOpen,
    title,
    openModal,
    closeModal,
    size,
    extendedProps,
    setExtendedProps
  }

  return modalReturn
}
